import { useTranslation } from 'react-i18next'

import { Button, Link } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ButtonsPreviewContent = ({ config }) => {
  const { t } = useTranslation()

  if (config.isLink) {
    return (
      <Styles.LinkWrapper>
        <Link>{t(config.activeLabel)}</Link>
      </Styles.LinkWrapper>
    )
  }

  return (
    <>
      <Button fullWidth variant={config.buttonVariant}>
        {t(config.activeLabel)}
      </Button>
      {config.disabledLabel && (
        <Button fullWidth variant={config.buttonVariant} disabled>
          {t(config.disabledLabel)}
        </Button>
      )}
    </>
  )
}

export default ButtonsPreviewContent
